
import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { VehicleType } from "../../vehicles-types/_types/vehicle-type";
import { Worker } from "../../workers/_types/worker";
import { Business } from "../../business/_types/business";
import { VehicleBrand } from "./vehicleBrand";
import { VehicleBrandModel } from "./vehicleBrandModel";
import { vehicleOwner } from "./vehicleOwner";
import { Bank } from "../../common/_types/bank";
import { StringComparisonConfig } from "@rxweb/reactive-form-validators/models/config/string-comparison-config";


export enum VehicleLeaseType {
    Renting = "Renting",
    OnProperty = "OnProperty",
    Leasing = "Leasing",
    Other = "Other"
}

export class Vehicle extends Resource {
    public override type = 'vehicles';

    @prop()
    @required()
    public name!: string;      

    @prop()    
    public workerId!: string;    

    @propObject(Worker)
    public worker: Worker = new Worker();
    
    @prop()    
    @required()
    public vehicleTypeId!: string;                

    @propObject(VehicleType)
    public vehicleType: VehicleType = new VehicleType();

    @prop()
    @required()
    public plate!: string;      
    
    @prop()
    public ownerType!: string;

    @prop()
    public businessId!: string;

    @propObject()
    public business!: Business;    

    @prop()
    public notes!: string;        

    @prop()
    public policyNumber?: string;    

    @prop()
    public policyDateStart?: Date;   

    @prop()
    public policyDateEnd?: Date;    

    @prop()
    public active: boolean = false;    

    @prop()
    public vehicleBrandId!: string;

    @propObject(VehicleBrand)
    public vehicleBrand!: VehicleBrand;

    
    @prop()
    public vehicleBrandModelId!: string;
    
    @propObject(VehicleBrandModel)
    public vehicleBrandModel!: VehicleBrandModel;

    @prop()
    public year!: number;

    @prop()
    public leaseType: VehicleLeaseType = VehicleLeaseType.Leasing;

    @prop()
    public policyValue?: number;

    @prop()
    public vehicleOwnerId?: string;
    @propObject(vehicleOwner)
    public vehicleOwner?: vehicleOwner;

    @prop()
    public dateStart?: Date;   

    @prop()
    public dateEnd?: Date;    

    @prop()
    public quoteNumbers?: number;    

    @prop()
    public quoteValue?: number;

    @prop()
    public kmInit?: number;

    @prop()
    public kmEnd?: number;

    @prop()
    public kmReaded?: Date;   
    
    @prop()
    public interestRate?: number;
    
    @prop()
    public hasFunding: boolean = true;    
    
    @prop()
    public bankId?: string;

    @propObject()
    public bank!: Bank;

    
    @prop()
    public typeOfDriver?: string;
    @prop()
    public yearPurchase!: number;

    @prop()
    public nameOfDriver?:string;

    @prop()
    public policyLastNotificationDate?: Date;

}